/* eslint-disable quotes */
// Russo
export const russo = {
  start: "Начать",
  save: "Сохранить",
  delete: "Удалить",
  update: "Обновить",
  lets: "Давайте играть",
  permanentbuy: "Постоянная Покупка",
  signature: "Ежемесячная Подписка",
  signatureano: "Годовая Подписка",
  male: "Мужчина  ",
  female: "Женщина",
  ambos: "Оба",
  inicio9: "Помощь",
  choosecategory: "Выберите категорию",
  categories: "Категории",
  light: "Свет",
  preliminary: "Предварительно",
  oral: "Со Ртом",
  anal: "Анус",
  hot: "Горячее",
  extreme: "Экстрим",
  vd: "Правда?",
  dare: "Смело ?",
  truth: "Правда",
  time: "Время",
  createMyChallenges: "Создать Мои Задания",
  chosen: "Избранное",
  text3: "Позвольте любви течь в вас!",
  text4: "Приготовьтесь к интересному",
  close: "Закрыть",
  dev: "Разработано Dev12BR",
  next: "ДАЛЕЕ",
  config3: "Без рекламы",
  config4: "Выбирайте более интересные аватары",
  config9: "Создавайте и редактируйте задания",
  config10: "Эксклюзивная категория",
  config11: "800+ новых заданий",
  version: "Премиум Версия",
  alert3: "Пожалуйста, выберите хотя бы одну категорию",
  tituloAlert1: "⚠️ Игра вот-вот начнется 😜",
  duvidas: "Вопросы или предложения - Пряные вызовы",
  description: "Здравствуйте, мой вопрос или предложение :",
  contact: "Свяжитесь с нами",
  botaoApple: "Восстановление покупок",
  alertCompra: "Ваши покупки восстанавливаются",
  NotPurchase: "У вас нет никаких покупок.",
  options: "Опции",
  avalie: "Оцените",
  novaCategoria: "Мои Категории",
  alterLanguage: "Изменить Язык?",
  textLanguage: "При выборе нового языка приложение перезапустится.",
  textLanguage1: "Переключить язык",
  cancel: "Отменить",
  languages: "Языки",
  deletCat: "Удалить категорию",
  textDeletCat:
    "При удалении категории задания, присутствующие в этой категории, будут удалены. После этого действия его уже нельзя будет отменить.",
  deletDes: "Удалить задание",
  textDeletDes: "После удаления задания это действие уже нельзя отменить.",
  desafio: "Зарегистрировать Новое Задание",
  desafiotexto: "Задание",
  textoeditDesafio: "Кто может это сделать?",
  textEmquem: "Кто ?",
  nome: "Имя",
  inicio: "Начать игру",
  cadastrarCategory: "Добавить Новую Категорию",
  inicio15: "Создать новую категорию",
  inicio16:
    "Шаг 1 : Нажмите кнопку со знаком +, которая находится в нижней части экрана. После нажатия появится окно для ввода новой категории.",
  inicio17: "Шаг 2: Введите новую категорию и нажмите сохранить",
  inicio18:
    "Шаг 3: Чтобы отредактировать эту категорию или ДОБАВИТЬ задачи в этой категории, нажмите на нее.",
  inicio19:
    "Шаг 4: На следующем экране, нажав на кнопку, обозначенную стрелкой ⬆️, откроется окно для редактирования новой категории.",
  inicio20:
    "Шаг 5: На следующем экране, нажав на кнопку со стрелкой ⬆️, вы удалите категорию.",
  inicio21:
    "Шаг 1: Нажмите кнопку ниже, чтобы добавить новую задачу в эту категорию",
  inicio22: "Создание новой задачи",
  inicio23:
    "Шаг 2: Нажмите на каждый обведенный кружком элемент, чтобы подробно ознакомиться с каждым полем регистра",
  inicio24: "Текст задачи",
  inicio25: `Напишите задание по своему вкусу, а чтобы имя игрока отображалось в задании, просто нажмите красную кнопку ниже. 
    
Он добавит следующие символы {nome}. 

** НЕ ИЗМЕНЯЙТЕ ЭТИ ШАБЛОНЫ ** Потому что для того, чтобы имя отображалось соответствующим образом, оно должно быть таким, как описано ниже ⬇️⬇️⬇️⬇️⬇️⬇️.

Задача: Поцеловать в шею {nome}`,
  inicio26: "Кто может делать, и кто может получать",
  inicio27: `Выберите "Both", если вызов может быть выполнен и принят участниками "обоих" полов.
  
Если вызов адресован одному полу, просто выберите нужный пол.
`,
  inicio28: "Добавление времени к задаче",
  inicio29:
    'Если у вашего задания есть время, просто перетащите "диапазон" ниже, и значение будет показано выше. По истечении времени испытания прозвучит звуковой сигнал, оповещающий об окончании испытания.',
  aviso12: `Здесь вы просто создаете категорию!
    
Чтобы добавить вызовы, просто нажмите на кнопку только что созданной категории ⬆️⬆️⬆️⬆️⬆️⬆️⬆️.`,
  voltar: "Вернуться",
  semDe: "Игрок без заданий",
  semDe2: `Зарегистрируйте хотя бы один вызов для этого игрока 😬. 
  
Вы будете перенаправлены на экран входа в систему.`,
  term: "Конфиденциальность",
  Potitic: "Условия использования",
  adquirited: "Приобретено",
  camera: "Камера",
  galery: "Галерея",
  avatar: "Аватары",
  image: "Изображение",
  seletion: " Избранное",
  editCategory: "Редактировать Категорию",
  frase1: "Вам нравятся задания?",
  frase2: "Как насчет того, чтобы попробовать Премиум Задания?",

  errTexto:
    "Если вы обнаружили ошибку в переводе, пожалуйста, исправьте предложение в поле ниже:",
  errTitulo: "Заметили что-то не так?",
  errCorrect: "Jak by to bylo v češtině?",
  thisLanguageIsCorrect: "Je úkol v ČEŠTINĚ správný?",
  yes: "Ano",
  no: "Ne",

  errSend: "Отправить предложение",
  send: "Отправить",
  share: "Поделиться",
  fraseShare: `Какое замечательное приложение! Просто делюсь, потому что знаю, что вам оно тоже понравится!
Скачай его, а потом скажи мне, если оно тебе не понравится, лол...😉
  
  
Ссылка для скачивания: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇷🇺",
  morePlayer: "Играть с большим количеством игроков ?",
  players: "Игроки",
  carregar: "Загрузить Изображение",
  takePhoto: "Сделайте фотографию или выберите изображение",
  useAvatar: "Или используйте Аватары",

  hetero: "Натурал",
  gay: "Гей",
  lesbico: "Лесбиянка",

  nomeHomem1: "Мужское Имя",
  nomeHomem2: "Мужское Имя",
  nomeMulher1: "Женское Имя",
  nomeMulher2: "Женское Имя",
  messageErr: "Добавь участников 🙌",
  descricaoErr: "Введите имена участников ✍️",
  why: "Расскажите нам, почему...",
  later: "Оценить Позже",

  txtCard1: "Твоя очередь 🔥",
  txtCard2: "Сделай это 😘",
  txtCard3: "Давай! 😜",
  txtCard4: "Следующая задача 😈",
  txtCard5: "Еще одна! 👄",

  tituloBloco1Novo: "Откройте сексуальную близость с партнером",
  subtitulo1Novo: "Более 1 миллиона счастливых пар",
  texto1Novo:
    "Откройте новые грани близости с партнером и получите доступ к лучшим играм для пар! Разблокируйте игры разных категорий, чтобы укрепить вашу связь.",
  tituloBloco2Novo: "Новые впечатления и лучшие отношения",
  texto2Novo1: "Наслаждайтесь +1500 задачами",
  texto2Novo2: "Создавайте свои собственные задания",
  texto2Novo3: "Эксклюзивные категории",
  texto2Novo4: "Без рекламы",
  texto2Novo5: "Уникальные аватары",
  texto2Novo6: "Ежедневные новые задания",
  texto2Novo7: "Регулярно обновляемые игры",
  tituloBloco3Novo: "Лидер рейтинга в категории",
  tituloBloco4Novo: "Преимущества для ваших отношений:",
  texto4Novo1: "Интимность",
  texto4Novo2: "Желание",
  texto4Novo3: "Легкость",
  texto4Novo4: "Притяжение",
  texto4Novo5: "Связь",
  texto4Novo6: "Удовольствие",

  tituloBloco5Novo: "Что говорят пары",
  texto5depoimentoTitulo1: "Антон Д.",
  texto5depoimento1: `Я думаю, что это лучшее приложение, которое я смог найти для телефона среди эротических приложений, я считаю, что ни одно приложение не может с ними сравниться, так что вы не пожалеете, если купите его. Я тоже сначала думал, но нисколько не пожалел. Вы упустите очень многое, если пожалеете $10.00, чтобы получить это приложение. Оно намного интереснее, чем игры, которые вы когда-либо пробовали в своей паре.`,
  texto5depoimentoTitulo2: "Алексей Владимирович",
  texto5depoimento2:
    "Это приложение потрясающее! Я сомневался, стоит ли его загружать, но это, безусловно, лучшее чувство, которое мы испытали с моей подругой за последнее время. Мы еще раз почувствовали, что мы все еще можем делать многие вещи вместе. 🤭 Мы протестировали платную версию, и она действительно того стоит, мы еще не достигли такого уровня удовольствия.",
  texto5depoimentoTitulo3: "Анна Семенова",
  texto5depoimento3:
    "Если вы хотите придать остроты отношениям, это приложение идеально подходит для вас! Я уже пробовала многие другие приложения, но ни одно не может сравниться с этим. Наши предварительные ласки стали намного жарче (а теперь представьте остальное!) Действительно стоит купить платную версию (если вы хотите почувствовать еще большее удовольствие), но и бесплатная версия удивит вас.",
  texto5depoimentoTitulo4: "Алина Аитова",
  texto5depoimento4:
    "Превосходное! Действительно, очень хорошее... Мы очень возбудились во время игры, что сделало секс намного более ярким, мы снова испытали удовольствие! Мы уже с нетерпением ждем возможности поиграть снова 💦🔥 мы также рекомендуем платную версию, если вы, ребята, хотите по настоящему возбудиться🤤 ",

  tituloBloco6Novo:
    "Присоединяйтесь к сотням пар по всему миру и добавьте пикантности вашим отношениям. Откройте более 800 новых заданий!",
  texto6Select: "Выберите версию:",
  texto6Premium: "Премиум",
  texto6Assinatura: "Подписка ",
  texto6Mensal: "Ежемесячно",
  texto6Anual: "Годовая",
  texto6Vitalicia: "Пожизненная лицензия",
  bePremium: "Получить Премиум",
  buyNew: "Купить",
  attention: "Внимание!",
  changeGender: "Вы изменили свою сексуальную ориентацию",

  tituloAvaliacao: "Вам нравится игра?",
  textoAvaliacao: "Оцените нас и помогите нам улучшаться!",
  agoraNão: "Сейчас нет",
  enviarAvaliacao: "Отправить",

  nomeJogo1: "Острые вызовы",
  nomeJogo2: "Правда или Действие?",
  nomeJogo3: "Уровень непослушания",
  nomeJogo4: "Игривая Рулетка",
  nomeJogo5: "Фраза дня",
  naughtyQuiz: "Непослушный викторина",

  playAlone: "Играть в одиночку",
  estaSozinho: "Вы одиноки?",
  selectPlayer: "Выберите игрока",

  skip: "Пропустить",
  responder: "Отправить",
  respondaAqui: "Ответьте здесь",
  config4: "Выберите аватары для настройки",

  tituloSelect1: "Играете в одиночку?",
  tituloSelect2: "Отвечайте на непристойные вопросы!",

  subTituloSelect1: "Мы поможем вам!",
  subTituloSelect2: "Узнайте, насколько вы непослушны!",
  txtJogador1:
    "Выберите своего игрока и исследуйте индивидуальные удовольствия, созданные специально для вас!",
  txtJogador2: "Выбранный игрок ответит на вопросы",
  tituloCena: "КАКИЕ ПРЕДМЕТЫ ВЫ ХОТИТЕ ИСПОЛЬЗОВАТЬ?",
  subTituloCena: `Нет некоторых? Нажмите "Получить" и приобретите в партнерском магазине`,
  play: "Играть",

  titleUserWarning: "Выберите пользователя",
  txtUserWarning: "Выберите пользователя для ответов на вопросы",

  shareNivelDeSafadeza:
    "Эй, посмотри на мой уровень шалости 😈 Почувствуй интенсивные моменты удовольствия. Ты тоже 💋 Скачай приложение сейчас и готовься к горячим испытаниям 🔥 с партнером: ➡️ https://пикантныевызовыприложение.page.link/sharelevelhot",

  shareDica:
    "Измени свою любовную жизнь прямо сейчас! Скачайте приложение и раскройте секрет пикантных отношений: ➡️ https://пикантныевызовыприложение.page.link/tipoftheday",

  resultadoQuiz1:
    "Вы сдержанный человек, вам не очень нравится пошлость, вы предпочитаете что-то более романтичное!",
  resultadoQuiz2:
    "Вы слишком романтичны, чтобы злоупотреблять пошлостью, и предпочитаете атмосферу свечей.",
  resultadoQuiz3:
    "Вы довольно сдержанный человек и верите в то, чтобы дела в интимной жизни оставались скрытыми и частными.",
  resultadoQuiz4:
    "Это не означает, что вы не можете быть шаловливыми иногда, но вы предпочли бы сохранить всю эту страсть для кого-то особенного.",
  resultadoQuiz5:
    "Ваша страсть находится на втором плане, но это не меняет факта, что в вас есть пламя!",
  resultadoQuiz6:
    "Вы любите исследовать новые впечатления, но всегда с уважением и согласием.",
  resultadoQuiz7:
    "Вам нравятся горячие свидания, полные поцелуев и страсти. Тем не менее, у вас есть сторона, которая также наслаждается просмотром фильмов, держа в руках своего возлюбленного или ужиная при свечах.",
  resultadoQuiz8:
    "Вы готовы попробовать новые и захватывающие вещи, но всегда с ответственностью.",
  resultadoQuiz9:
    "Вы смелый человек и иногда любите придать своей интимной жизни пикантности.",
  resultadoQuiz10:
    "Вам нравится наслаждаться всеми удовольствиями жизни, и у вас нет ограничений, когда речь идет о сексе.",
  resultadoQuiz11:
    'С вами не бывает скучных моментов, и всегда можно устроить быстрый интим! Фильмы о романтике? Только "50 оттенков серого"!',
  resultadoQuiz12:
    "Для вас близость - это постоянное приключение, и вы не боитесь рисков.",
  mes: "Месяц",
  desafiosRestantesDois: "У вас осталось 2 премиум-вызова!",
  nenhumDesafioRestante: "Нет оставшихся премиум-вызовов!",
  tornePremiumAviso1:
    "Станьте премиум сейчас и наслаждайтесь 1000 эксклюзивными вызовами!",
  tornePremiumAviso2:
    "Наслаждайтесь неограниченными испытаниями, эксклюзивным контентом и непрерывным весельем!",
  conteudoPremium: "Вы выбрали премиум-контент!",
  aproveite4desafios:
    "Воспользуйтесь 4 премиум-вызовами, чтобы испытать эксклюзивное удовольствие.",
  calculando: "Расчет результатов...",
  nivelRomantismo: "Ваш уровень романтики...",
  finalizar: "Закончить",
  erroQuizTitulo: "Введите свой ответ",
  erroQuizFrase: "Чтобы продолжить, введите свой ответ!",
  new: "Новое приложение",

  //resposta quiz safadeza

  resQuiz1: "Нежный",
  resQuiz2: "Страстный",
  resQuiz3: "Очаровательный",
  resQuiz4: "Супер непослушный",

  texto6Semanal: "Еженедельно",
  weekly: "Еженедельная подпись",

  tempSemanal: "Списывается еженедельно",
  tempMensal: "Списывается ежемесячно",
  tempAnual: "Списывается ежегодно",
  tempSempre: "Одноразовый платеж",
  canceleAny: "Отменить в любое время",

  //Tela do safadrometro
  Low: "Низкий",
  Medium: "Средний",
  High: "Высокий",

  lifeTime: "Доступ на всю жизнь",
  notNow: "Не сейчас, спасибо",
  match: "СВАЙП С И.И.",

  dateTitle: "Хотите ознакомиться с нашим новым приложением?",

  dateBody: `Хотите пообщаться с озорными 😈 ботами и потренировать свои умения флирта? Вам будет весело!🔥`,
  goToDate: "Попробуйте Date.AI сейчас!",
  goodForU: "БЫЛО ХОРОШО ДЛЯ ВАС?",
  rateOurPerformance: "Оцените нашу работу на данный момент",
  veryGood: "Очень хорошо",
  veryBad: "Очень плохо",
  feedbackChallenge: `Что заставило бы вас поделиться приложением Hot Challenges с другими парами и почему?`,
  type: "Напишите свой ответ здесь...",
  survey: "Опрос удовлетворенности.",
  shareIfConfortable:
    "Чувствуйте себя свободными, чтобы поделиться с друзьями, если вам удобно :)",

  howToPlay: "Как играть",
  howToPlayHotChallenge:
    "Приготовьтесь добавить огня! Вытяните карту с вызовом и удивите своего партнера горячим действием!",

  preGameTip1:
    "Освободите свои желания и создайте незабываемые моменты с вашим партнером!",
  preGameTip2: "Разожгите свои страсти и создайте незабываемые моменты вместе!",
  preGameTip3:
    "Исследуйте свои самые дикие желания и создайте незабываемые воспоминания!",
  preGameTip4:
    "Освободите свои фантазии и наслаждайтесь моментами чистого удовольствия!",
  selecionajoagador: "Время играть",
  dica: "Подсказка",
  howToPlayNaughty:
    "Выберите свои любимые игрушки и предметы. Вращайте колесо и позвольте судьбе выбрать ваш следующий озорной вызов!",
  howToPlayTruthOrDare:
    "Выбери свою судьбу: расскажи правду или прими смелый вызов. Пусть веселье начнется!",

  howToKama1: "Откройте Позиции Удовольствия – 365 Дней Страсти!",
  howToKama2:
    "Выберите случайную карту, попробуйте позу и вместе исследуйте новые вершины наслаждения!",
  kamaExplain:
    "Разблокируйте новую позу каждый день и создайте свою идеальную коллекцию страсти – ваше путешествие к 365 дням незабываемого удовольствия начинается здесь!",
  howToDo: "Как сделать",
  pergunta: "Вопрос",

  restart: "Перезапуск",
  dialogText1HotChallenges:
    "Вы выполнили все доступные задачи с выбранными категориями.",
  dialogText2HotChallenges:
    "Выберите больше категорий или перезапустите игру с текущими задачами!",
  noChallenges: "Нет задач!",

  objects: "Объекты",
  dialogText1NaughtyGames:
    "Вы завершили все доступные испытания с выбранными объектами.",
  dialogText2NaughtyGames:
    "Выберите больше объектов или перезапустите игру с текущими испытаниями!",
  unlockPremium: "Разблокировать премиум-доступ",
  noCategory: "Пожалуйста, выберите хотя бы одну категорию, чтобы начать.",
  thanksForFeedback: "Спасибо, что помогаете нам улучшить опыт!",
  categoryKamasutra: "Выберите свою страсть и играйте!",
  tap: "Нажмите, чтобы раскрыть свою позицию!",
  step: "Пошаговое Руководство",
  shareQuizButton: "Поделись своим уровнем озорства!",
  tryAgain: "Попробуйте снова",
  unlockAllFun: "Разблокируйте все развлечения",
  limitedOffer: "Специальное предложение на ограниченное время!",
  fill: "Введите ваше имя и имя вашего партнера или партнерши.",

  kamaNotificationTitle: "🔥 Ваша новая карта разблокирована!",
  kamaNotificationBody:
    "Ваша позиция на {variavel}-й день готова. Как насчёт попробовать сегодня что-то новое? 💋",

  titleNewGame: "Готовьтесь к ролевым играм!",
  phraseNewGame:
    "В следующем обновлении появится новая игра, позволяющая исследовать самые креативные фантазии. Выбирайте персонажей, создавайте истории и поднимайте удовольствие на новый уровень с партнером. 🔥",
  awaitNewGame: "Ждите и готовьтесь к уникальным моментам!",

  selectObjects:
    "Выберите два или более предмета, чтобы настроить игру. Исследуйте по максимуму.",
  soon: "Скоро",
  wantToBeNotify: "Я хочу быть уведомленным",
  ok: "OK",
  vezDe: "ПОВОРОТ",

  categoryLabel: "Категория",
  descriptionLabel: "Описание",

  loginConnect: "Войти",
  loginNoAccount: "Нет аккаунта?",
  loginCreateNow: "Создать сейчас",
  loginOrConnect: "или войти с помощью",

  email: "Электронная почта",
  password: "Пароль",
  loginRegister: "Зарегистрироваться",
  loginAlreadyHas: "Уже есть аккаунт?",
  enterNow: "Войти сейчас",

  logout: "Выйти",
  customerPortal: "Портал клиента",
  installApp: "Установить приложение",

  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/russo.mp4",
};
